import { InfoDocumentComponent } from "../InfoDocumentComponent";
import privacyPolicyContent from "./content";

export const PrivacyPolicy = () => <InfoDocumentComponent content={privacyPolicyContent} />;
